import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
    OutOfBoundsNavigationHeader,
    UiCalendarComponent,
} from '@components/ui-calendar/ui-calendar.component';
import { DirectivesModule } from '@directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatDatepickerModule,
        DirectivesModule,
    ],
    declarations: [
        UiCalendarComponent,
        OutOfBoundsNavigationHeader,
    ],
    exports: [
        UiCalendarComponent,
    ],
    entryComponents: [
        OutOfBoundsNavigationHeader,
    ],
})
export class UiCalendarModule { }
